import { Card, CardContent, Typography } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import IndustryRoi from "./industry-roi/IndustryRoi";
import PE from "./pe/PE";


const DashboardStock = () => {
  return (
    <Card sx={{ boxShadow: "none" }}>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            fontSize: { xs: "16px", lg: "18px" },
            fontWeight: 700,
          }}
        >
          سهام
        </Typography>
        <Grid2 container spacing={2}>
          <Grid2 xs={12} lg={6}>
            <IndustryRoi />
          </Grid2>
          <Grid2 xs={12} lg={6}>
            <PE />
          </Grid2>

        </Grid2>
      </CardContent>
    </Card>
  );
};

export default DashboardStock;
